import { render } from "./BrandLink.vue?vue&type=template&id=4e2dab78"
import script from "./BrandLink.vue?vue&type=script&lang=js"
export * from "./BrandLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/app/header/BrandLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e2dab78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e2dab78', __exports__)) {
    console.log('reload')
    api.reload('4e2dab78', __exports__)
  }
  
  module.hot.accept("./BrandLink.vue?vue&type=template&id=4e2dab78", () => {
    console.log('re-render')
    api.rerender('4e2dab78', render)
  })

}


export default __exports__